import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { dnsCheck } from "@forproxyband/react-tools";

import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import {
  useClientSelectors,
  useDnsCheckAdapter,
  useToolsScan,
} from "../../../hooks";

import { Container, WidgetTable } from "../../../components";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Seo } from "../../../components/Seo/Seo";
import AccordionTable from "../../../components/common/AccordionTable";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import { WidgetStatus } from "../../../components/common/WidgetStatus/WidgetStatus";

import { Section } from "../../../components/common/Section/Section.styled";
import { GridItem, StyledGrid, StyledStack } from "./CheckDns.styled";

const CheckDns = () => {
  const [showLoader, setShowLoader] = useState(true);

  const { showResult, setShowResult } = useToolsScan();
  const [dns, setDns] = useState([]);

  const { info } = useClientSelectors();
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const result = await dnsCheck.check();

      if (result) {
        setDns(prevState => [...prevState, result]);
      }
    })();
  }, []);

  const handleFinish = () => {
    setShowLoader(false);
    setShowResult(true);
  };

  const restartDnsLeakTest = () => {
    setShowLoader(true);
    setShowResult(false);
  };

  const {
    headerData,
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
  } = useDnsCheckAdapter();

  const dnsStatus = dns[0];

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          <StyledStack>
            <StyledGrid>
              {showLoader ? (
                <LoadingSpinner onFinish={handleFinish} />
              ) : (
                <GridItem>
                  <WidgetTable
                    backData={info}
                    button={t("dnsCheck.checkButton")}
                    params={["provider", "country"]}
                    onButtonClick={restartDnsLeakTest}
                  />
                </GridItem>
              )}

              {showLoader ? (
                <WidgetStatus />
              ) : (
                <WidgetStatus
                  status={dnsStatus ? "error" : "success"}
                  title={
                    dnsStatus
                      ? t("dnsCheck.notProtectTitle")
                      : t("dnsCheck.protectTitle")
                  }
                  description={
                    dnsStatus
                      ? t("dnsCheck.notProtect")
                      : t("dnsCheck.protected")
                  }
                />
              )}
            </StyledGrid>

            {showResult && (
              <AccordionTable
                data={dns}
                headerData={headerData}
                renderDropdownContent={renderDropdownContent}
                renderHeaderTitle={renderHeaderTitle}
                renderRowContent={renderRowContent}
                showStatus={false}
              />
            )}
          </StyledStack>
        </Container>
      </Section>

      <Faq sectionType="innerTools" />
      <Seo sectionType="innerTools" />
    </>
  );
};

CheckDns.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default CheckDns;
